import clsx from 'clsx';

export const WasteValue = (ps: { value: number }) => (
  <span
    className={clsx(
      'font-bold',
      ps.value > 0 ? 'text-red-500' : 'text-inherit',
    )}>
    {ps.value}
  </span>
);
